export default __webpack_public_path__ + "static/media/android-studio.42e5e8e1.png";